import { PermissionNotificationCatalogueEntryModel } from 'models';
import request, { Methods } from 'utils/request';
import { EntityService } from 'utils/entityService';

class PermissionNotificationService extends EntityService {
  constructor() {
    super('permission-notifications');
  }

  async getNotificationCatalogue() {
    return request<PermissionNotificationCatalogueEntryModel[]>({
      method: Methods.GET,
      resource: this.resource,
    });
  }
}

export const permissionNotificationService = new PermissionNotificationService();
